import { Tabs } from '@zillow/constellation-10';

const RentalJourneyFiltersSkeleton = (): JSX.Element => {
  return (
    <Tabs.Root>
      <Tabs.List>
        <Tabs.Tab value="view-all">View All</Tabs.Tab>
        <Tabs.Tab value="inquiries">Inquiries</Tabs.Tab>
        <Tabs.Tab value="tours">Tours</Tabs.Tab>
        <Tabs.Tab value="applicants">Applicants</Tabs.Tab>
        <Tabs.Tab value="tenants">Tenants</Tabs.Tab>
      </Tabs.List>
    </Tabs.Root>
  );
};

export default RentalJourneyFiltersSkeleton;
